import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CustomsnapshotService } from '../Services/customsnapshot.service';
import { SnapshotService } from '../Services/snapshot.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-output-popup',
  templateUrl: './output-popup.component.html',
  styleUrls: ['./output-popup.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutputPopupComponent {
  @Output() dataEvent = new EventEmitter<boolean>();
  @Output() dataEventTrend = new EventEmitter<boolean>();
  @Output() dataEventCustom = new EventEmitter<boolean>();
  @Input() popUpParameter = '';
  @Input() visualization = '';
  @Input() id: number | undefined;
  @Input() item: any;
  @Input() data: any;
  @Input() customData: any;
  @Input() snapProduct: string = '';
  @Input() multiFunnelPopup: boolean = false;
  @Input() brandList: any = []
  @Input() metricList: any = [];
  @Input() initialMetric: any = null;
  @Input() initialBrand: any = null;
  @Input() trendLineView: any;
  @Input() showSnapshotARK: any;
  isviewDropdownOpen: any = false;
  clickedResult = '';
  Top10Container: boolean = false;
  Top10Toggle: boolean = true;
  DataLabelOn: boolean = true;
  BMList: any = [];
  viewList: any = [];
  charttype: string = "";
  zAxisMetric: string = "";

  get popupHeaderDisplay(): string {
    const rawHeader = (this.popUpParameter ?? '').toString();
    if (this.visualization !== 'Line Chart') {
      return rawHeader;
    }

    const parts = rawHeader.split(' - ');
    if (parts.length <= 1) {
      return rawHeader;
    }

    return parts.slice(0, -1).join(' - ').trim();
  }

  private getBrandFromWidgetLabel(): string {
    const labelSources = [this.popUpParameter, this.customData?.widget_name, this.item?.widget_name];
    for (const source of labelSources) {
      const rawLabel = (source ?? '').toString().replace(/<[^>]*>/g, '').trim();
      if (!rawLabel || !rawLabel.includes(' - ')) {
        continue;
      }

      const candidate = rawLabel.split(' - ').pop()?.trim() ?? '';
      if (candidate) {
        return candidate;
      }
    }

    return '';
  }

  private normalizeBrandValue(value: any): string {
    const rawValue = (value?.option ?? value ?? '').toString().trim();
    if (!rawValue) {
      return '';
    }

    return (rawValue.includes('|') ? rawValue.split('|').pop() : rawValue)
      ?.toString()
      .trim()
      .toLowerCase();
  }

  private getPreferredBrandOption(): any {
    const brandCandidates = [
      this.getBrandFromWidgetLabel(),
      this.brandSelected,
      this.initialBrand,
    ];
    for (const candidate of brandCandidates) {
      const normalizedCandidate = this.normalizeBrandValue(candidate);
      if (!normalizedCandidate) {
        continue;
      }
      const match = this.brandList?.find(
        (brand: any) => this.normalizeBrandValue(brand) === normalizedCandidate,
      );
      if (match) {
        return match?.option ?? match;
      }
    }
    return this.brandList?.[0]?.option ?? this.brandList?.[0] ?? '';
  }

  private syncPreferredBrandSelection(): void {
    if (!this.brandList?.length) {
      return;
    }

    const preferredBrand = this.getPreferredBrandOption();
    this.brandSelected = preferredBrand;
    this.brandList.forEach((brand: any) => {
      brand.selected = this.normalizeBrandValue(brand.option) === this.normalizeBrandValue(preferredBrand);
    });

    if (
      this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands" &&
      this.viewselected == "All Metrics for Selected Brand"
    ) {
      this.metricSelected = "";
      this.BMList = this.brandList;
    }
  }

  viewListBrands: any[] = [
    {
      option: "All Brands for Selected Metric",
      selected: true,
    }, {
      option: "All Metrics for Selected Brand",
      selected: false,
    },
  ]
  viewListMarkets: any = [
    {
      option: "All Markets for Selected Metric",
      selected: true,
    }, {
      option: "All Metrics for Selected Market",
      selected: false,
    },
  ]

  constructor(private _cdref: ChangeDetectorRef, private _configCustomService: CustomsnapshotService, public _configService: SnapshotService) {
    this.viewList = this.viewListBrands;

  }

  gridData: any = [];
  toogleBrandMetricDropdownOpen: any = false;
  searchText: string = '';
  toogleViewDropdown() {
    this.isviewDropdownOpen = !this.isviewDropdownOpen;
    event?.stopPropagation();
  }
  closeViewDropdown() {
    this.isviewDropdownOpen = false;
  }
  toogleBrandMetricDropdown() {
    this.toogleBrandMetricDropdownOpen = !this.toogleBrandMetricDropdownOpen
    event?.stopPropagation();
  }


  isTrendView: boolean = true;
  isSampleSize: boolean = false;
  isLollipopMetricModeActive: boolean = false;
  toggleTrendSample(view: any) {
    if (view == 'trendview') {
      this.isTrendView = true;
      this.isSampleSize = false;
    }
    else {
      this.prepareSampleSize();

    }
  }

  closeBrandMetricDropdown() {
    this.toogleBrandMetricDropdownOpen = false;
     this.searchText = '';
  }

  getFilteredBMList() {
    if (!this.searchText) {
      return this.BMList;
    }
    return this.BMList.filter((item: any) =>
      item.option.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }


  onSearchInput(event: any) {
    this.searchText = event.target.value;
  }

  private normalizeOptionValue(value: any): string {
    return typeof value === 'string' ? value.trim() : '';
  }

  private resolveSourceChartType(widget: any): string {
    return (
      widget?.sourceWidgetChartName ??
      widget?.widgetchart_name ??
      ''
    )
      .toString()
      .trim()
      .toLowerCase();
  }

  private isGaugeTrendWidget(): boolean {
    return this.resolveSourceChartType(this.customData) === 'gauge';
  }

  private isMetricOnlyTrendWidget(): boolean {
    if (this.customData?.useMetricTrendSeries === true) {
      return true;
    }
    if (this.isGaugeTrendWidget()) {
      return true;
    }

    if (this.customData?.isBrandDependent === true) {
      return false;
    }

    if (this.customData?.isBrandDependent === false) {
      return true;
    }

    try {
      const rawProps = this.customData?.customizationProperties;
      const props =
        typeof rawProps === 'string'
          ? JSON.parse(rawProps || '{}')
          : rawProps || {};
      if (props?.bdBiToggle === false || props?.bdBiToggle === 'false') {
        return true;
      }
    } catch {
      // fall through
    }

    return false;
  }

  private buildMetricDropdownOptions(metrics: any[] = []): any[] {
    const seen = new Set<string>();
    const options: string[] = [];

    metrics.forEach((metric: any) => {
      const optionValue = this.normalizeOptionValue(
        metric?.option ?? metric?.metricName,
      );
      if (!optionValue) {
        return;
      }

      if (seen.has(optionValue.toLowerCase())) {
        return;
      }

      seen.add(optionValue.toLowerCase());
      options.push(optionValue);
    });

    return options.map((option: string, index: number) => ({
      option,
      selected: index === 0,
    }));
  }

  private ensureTrendPopupMetricList(): void {
    if (
      this.visualization !== 'Line Chart' ||
      this.trendLineView !== 2 ||
      this.metricList.length > 0
    ) {
      return;
    }

    const fallbackMetrics = this.buildMetricDropdownOptions(
      this.customData?.metric?.[0]?.metric_value || [],
    );

    if (fallbackMetrics.length === 0) {
      return;
    }

    this.metricList = fallbackMetrics;
    this.BMList = this.metricList;
    this.metricSelected =
      this.metricList.find((item: any) => item.selected)?.option || '';
  }

  ngOnInit() {

    if (this.snapProduct == "custom") {
      const FoundItem = this.customData.metric.find((item: any) => item.metric_option === "ZAxis Metric : ");
      if (FoundItem)
        this.zAxisMetric = FoundItem.metric_value[0].option;
      //  this.zAxisMetric = this.customData.metric.find((item:any) => item.metric_option === "ZAxis Metric : "
      //                                                           ).metric_value[0].option;
      this.charttype = this.customData.widgetchart_name;
      if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
        this.viewList = this.viewListBrands;
        const defaultViewIndex = this.isLollipopMetricMode() && this.viewList[1] ? 1 : 0;
        this.viewselected = this.viewList[defaultViewIndex].option;
        this.viewList = this.viewList.map((v: any, idx: number) => ({
          ...v,
          selected: idx === defaultViewIndex
        }));
      }
      if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
        this.viewList = this.viewListMarkets;
        this.viewselected = this.viewList[0].option;
      }
      if (this.multiFunnelPopup) {
        const isAudienceSnapshot = this._configService.selectedSnapshotType.toLowerCase().includes('audience') && this._configService.multiCohort;
        this.customData.metric[0].metric_value[0].data.forEach((d: any) => {
          // For audience snapshot, extract the audience name from colChild (e.g., "Audience|Gender|Male" -> "Male")
          let headerValue = d.colChild ?? '';
          if (isAudienceSnapshot && d.colChild && d.colChild.includes('|')) {
            headerValue = d.colChild.split('|').pop() ?? '';
          }
          this.gridData.push({
            header: headerValue,
            data: this.customData
          })
        })
      }
      if (this.metricList.length > 0) {
        const preselected = this.initialMetric && this.metricList.find((m: any) => m === this.initialMetric);
        this.metricSelected = preselected || this.metricList[0];
        this.metricList = this.metricList.map((m: any) => {
          return {
            option: m,
            selected: m === this.metricSelected
          }
        })

      }
      this.ensureTrendPopupMetricList();
      if (this.brandList.length > 0) {
        const normalizedInitialBrand = this.normalizeBrandValue(this.initialBrand);
        const preselectedBrand = this.initialBrand && this.brandList.find(
          (brand: any) => this.normalizeBrandValue(brand) === normalizedInitialBrand,
        );
        this.brandSelected = preselectedBrand || "";
        this.brandList = this.brandList.map((m: any, index: any) => {
          return {
            option: m,
            selected: m === preselectedBrand || (!preselectedBrand && index === 0)
          }
        })

      }
      if (this.isMetricOnlyTrendWidget()) {
        this.metricSelected = '';
        this.brandSelected = '';
        this.BMList = [];
      } else if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands" && this.viewselected == "All Metrics for Selected Brand") {
        this.metricSelected = "";
        this.syncPreferredBrandSelection();
      } else {
        if (!this.metricSelected) {
          this.metricSelected = this.metricList?.[0]?.option ?? '';
        }
        this.brandSelected = '';
        this.BMList = this.metricList;
      }
    }
    else {
      if (
        this.data[0].metricSelected.metrics.length > 10 &&
        this.visualization === 'Line Chart'
      ) {
        this.Top10Container = true;
      }
      if (this.visualization == 'Funnel Chart') {
        this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
      }
      if (this.Top10Container == true) {
        this.Top10Toggle = true;
      }
    }

    if (this._configService.weights && this._configService.weights.length > 0) {
      this.weightSelectedValue = this._configService.weights[0]?.key;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.snapProduct == "custom" &&
      (changes['initialBrand'] || changes['brandList']) &&
      this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands" &&
      this.viewselected == "All Metrics for Selected Brand"
    ) {
      this.syncPreferredBrandSelection();
    }

    if (this.visualization == 'Funnel Chart') {
      this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
    }
  }
  viewselected: any = "All Brands for Selected Metric";
  viewSelected(item: any) {
    this.viewList.forEach((v: any) => {
      if (item.option == v.option) {
        v.selected = true;
        this.viewselected = v.option;
        if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
          if (v.option == "All Brands for Selected Metric") {
            this.brandSelected = "";
            this.metricList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.BMList = this.metricList;
          }
          else {
            this.metricSelected = "";
            this.syncPreferredBrandSelection();
          }
        }
        if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
          if (v.option == "All Markets for Selected Metric") {
            this.brandSelected = "";
            this.metricList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.BMList = this.metricList;
          }
          else {
            this.metricSelected = "";
            this.brandList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.brandSelected = this.brandList[0].option;
            this.BMList = this.brandList;
          }
        }
      }
      else {
        v.selected = false;
      }
      this._cdref.detectChanges();
    })
  }
  metricSelected: any = "";
  brandSelected: any = "";
  brandMetricSelected(item: any, itemindex: any) {
    if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
      if (this.viewselected == "All Brands for Selected Metric") {
        this.metricList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.metricSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
      else {
        this.brandList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.brandSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
    }
    if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
      if (this.viewselected == "All Markets for Selected Metric") {
        this.metricList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.metricSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
      else {
        this.brandList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.brandSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
    }
  }

  Top10selected() {
    this.Top10Toggle = true;
  }

  Allselected() {
    this.Top10Toggle = false;
  }

  DataLabelOnClick() {
    this.DataLabelOn = true;
  }

  DataLabelOffClick() {
    this.DataLabelOn = false;
  }

  collapseExandPopup() {
    this.dataEvent.emit(false);
    this.dataEventCustom.emit(false);

    this.dataEventTrend.emit(false);
  }


  opobject: any = {
    Column: [], Row: []
  }
  TrendToggleContainer: boolean = false;
  TrendToggleOn: boolean = false;
  weightSelectedValue: any = "";
  sampleSizeOutputData: any = [];
  OutputdataObject: any = {
    Column: [], Row: []
  }

  private isBrandIndependentWidgetForSampleSize(widget: any): boolean {
    if (widget?.isBrandDependent === true) {
      return false;
    }
    if (widget?.isBrandDependent === false) {
      return true;
    }
    try {
      const props = JSON.parse(widget?.customizationProperties || '{}');
      if (props?.bdBiToggle === false || props?.bdBiToggle === 'false') {
        return true;
      }
    } catch {
      // ignore malformed customizationProperties
    }
    return Array.isArray(widget?.audience) && widget.audience.length > 0;
  }

  private isTimePeriodColChild(colChild: any): boolean {
    const raw = (colChild ?? '').toString().trim();
    if (/^(Quarter|Month|Week|Year|Time Period)\|/i.test(raw)) {
      return true;
    }
    return /^Q\s?\d+_\d{4}$/i.test(raw.replace(/\s+/g, ' '));
  }

  private normalizeSampleSizePeriod(value: any): string {
    return (value ?? '')
      .toString()
      .replace(/^(Quarter|Month|Week|Year|Time Period)\|/i, '')
      .replace(/\s+/g, '')
      .toLowerCase();
  }

  private resolveSampleSizeRowPeriod(
    row: any,
    isBrandIndependent: boolean,
  ): string {
    if (!isBrandIndependent) {
      return row.Level1ColChild ?? row.lvl1Child ?? '';
    }

    const level1 = (row.Level1ColChild ?? row.lvl1Child ?? '').toString();
    const col = (row.colChild ?? '').toString();
    const levelIsTp = this.isTimePeriodColChild(level1);
    const colIsTp = this.isTimePeriodColChild(col);

    if (colIsTp && levelIsTp) {
      if (this.normalizeSampleSizePeriod(col) !== this.normalizeSampleSizePeriod(level1)) {
        return col;
      }
    }

    if (levelIsTp) {
      return level1;
    }
    if (colIsTp) {
      return col;
    }
    return level1;
  }

  private sampleSizeRowHasData(row: any): boolean {
    const fields = [
      'totalUnweightedBase',
      'answerUnweightedBase',
      'totalWeightedBase',
      'answerWeightedBase',
      'totalWeightedNumerator',
      'answerWeightedNumerator',
      'CurrentNumeratorUnWeighted_Total',
      'CurrentNumeratorUnWeighted_Answer',
    ];
    return fields.some(
      (field) =>
        row?.[field] !== null &&
        row?.[field] !== undefined &&
        row?.[field] !== 0,
    );
  }

  private preferSampleSizeTrendRow(candidate: any, current: any): boolean {
    const candidateHasData = this.sampleSizeRowHasData(candidate);
    const currentHasData = this.sampleSizeRowHasData(current);
    if (candidateHasData && !currentHasData) {
      return true;
    }
    if (!candidateHasData && currentHasData) {
      return false;
    }

    const candidatePeriod = this.normalizeSampleSizePeriod(
      this.resolveSampleSizeRowPeriod(candidate, true),
    );
    const candidateCol = this.normalizeSampleSizePeriod(candidate?.colChild);
    const currentCol = this.normalizeSampleSizePeriod(current?.colChild);
    if (candidateCol === candidatePeriod && currentCol !== candidatePeriod) {
      return true;
    }
    if (candidateCol !== candidatePeriod && currentCol === candidatePeriod) {
      return false;
    }

    return false;
  }

  private filterBrandIndependentTrendSampleSizeRows(rows: any[]): any[] {
    const periodRows = rows.filter(
      (row: any) =>
        this.isTimePeriodColChild(row.Level1ColChild) ||
        this.isTimePeriodColChild(row.colChild),
    );
    const candidateRows = periodRows.length > 0 ? periodRows : rows;

    const bestByKey = new Map<string, any>();
    candidateRows.forEach((row: any) => {
      const period = this.resolveSampleSizeRowPeriod(row, true);
      const key = `${row.rowChild ?? ''}||${this.normalizeSampleSizePeriod(period)}`;
      const existing = bestByKey.get(key);
      if (!existing || this.preferSampleSizeTrendRow(row, existing)) {
        bestByKey.set(key, row);
      }
    });

    return Array.from(bestByKey.values());
  }

  private extractBrandNameFromColChild(colChild: any): string {
    const raw = (colChild ?? '').toString().trim();
    if (!raw || this.isTimePeriodColChild(raw)) {
      return '';
    }
    if (raw.startsWith('Brands|')) {
      const brandPart = raw.substring('Brands|'.length).trim();
      return brandPart.includes('|')
        ? (brandPart.split('|').pop()?.trim() ?? brandPart)
        : brandPart;
    }
    return raw.includes('|') ? (raw.split('|').pop()?.trim() ?? '') : raw;
  }

  private getSampleSizeBrandLabel(
    row: any,
    parentRow: any,
    isBrandIndependent: boolean,
  ): string {
    if (isBrandIndependent) {
      return '';
    }
    return (
      this.extractBrandNameFromColChild(row?.colChild) ||
      this.extractBrandNameFromColChild(parentRow?.colChild) ||
      'NA'
    );
  }

  private matchesSampleSizeWidget(
    row: any,
    widgetNames: string[],
  ): boolean {
    // Trend-as-Widget chart points may omit widgetName; restore path stamps it,
    // but treat missing name as in-scope when data is already single-widget.
    if (!row?.widgetName) {
      return true;
    }
    return widgetNames.indexOf(row.widgetName) > -1;
  }

  private normalizeSampleSizeTrendRow(row: any): any {
    return {
      ...row,
      Level1ColChild: row.Level1ColChild ?? row.lvl1Child ?? '',
      widgetName:
        row.widgetName ||
        this.customData?.widget_name ||
        this.item?.widget_name ||
        '',
    };
  }

  prepareSampleSize() {
    this.isLollipopMetricModeActive = this.isLollipopMetricMode();
    this.opobject = {
      Column: [], Row: []
    }


    this.TrendToggleContainer = true;
    this.TrendToggleOn = true;
    let data = [this.customData]

    const widgetDetailsInParticularPage = data.map((item: any) => item.widget_name);
    const scopedTrendRows = (this._configService.trendOutputDbCallData || [])
      .map((row: any) => this.normalizeSampleSizeTrendRow(row))
      .filter((i: any) =>
        this.matchesSampleSizeWidget(i, widgetDetailsInParticularPage),
      );

    let uniqueObjects = [
      ...new Map(
        scopedTrendRows.map((item: any) => [item.widgetName, item])
      ).values()
    ];

    let pagedetails = _.cloneDeep(scopedTrendRows);

    const isBrandIndependent =
      this.isBrandIndependentWidgetForSampleSize(this.customData);

    uniqueObjects.forEach((i: any) => {
      let widgetRows = pagedetails.filter((p: any) => p.widgetName == i.widgetName);
      if (isBrandIndependent) {
        widgetRows = this.filterBrandIndependentTrendSampleSizeRows(widgetRows);
      }

      let nestedArray1 = widgetRows.map((p: any) => {
          const resolvedPeriod = isBrandIndependent
            ? this.resolveSampleSizeRowPeriod(p, true)
            : (p.Level1ColChild ?? '');

          return {
            CalculationType: p.CalculationType,
            Child: p.rowChild,
            Level1ColChild: resolvedPeriod,
            colChild: p.colChild ?? '',
            NestedArray: [],
            customCalculationId: p.customCalculationId || null,
            customGroupId: p.customGroupId || null,
            isCustomCalculation: p.isCustomCalculation || false,
            isCustomGroup: p.isCustomGroup || false,
            isDerived: p.isDerived || false,
            responsecode:  p.rowResponseCode?.toString() ?? null,
            variablecode: p.rowVariableCode,
            unweightedBase:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.totalUnweightedBase
                : p.answerUnweightedBase,
            weightedBase:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.totalWeightedBase
                : p.answerWeightedBase,
            WeightedNumerator:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.totalWeightedNumerator
                : p.answerWeightedNumerator,
            UnweightedNumerator:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.CurrentNumeratorUnWeighted_Total
                : p.CurrentNumeratorUnWeighted_Answer,
            trend: true,
            brand: this.getSampleSizeBrandLabel(p, i, isBrandIndependent),
            ChildName: p.rowChild.includes("|") ? p.rowChild.split("|")[1].trim() : p.rowChild
          };
        });


      this.opobject.Row.push({
        Data: [{
          CalculationType: i.CalculationType || "share",
           Child: widgetDetailsInParticularPage[i.widgetName] ?  i.widgetName + '_' + widgetDetailsInParticularPage[i.widgetName].trim() : i.widgetName,
          Level1ColChild: i.Level1ColChild ?? '',
          NestedArray: nestedArray1,
          customCalculationId: i.customCalculationId || null,
          customGroupId: i.customGroupId || null,
          isCustomCalculation: i.isCustomCalculation || false,
          isCustomGroup: i.isCustomGroup || false,
          isDerived: i.isDerived || false,
          responsecode: "1",
          variablecode: "MO_MOb_2b_DAYPART",
          ChildName: (i.Level1ColChild ?? '').includes("|") ? (i.Level1ColChild ?? '').split("|")[1].trim() : (i.Level1ColChild ?? '')
        }
        ],
        Data1: [{ NestedArray: [] }],
        Parent: i.colChild ?? '',
        customCalculationId: i.customCalculationId || null,
        customGroupId: i.customGroupId || null,
        isCustomCalculation: i.isCustomCalculation || false,
        isCustomGroup: i.isCustomGroup || false
      })
    })

    let uniqueColObjects = Object.values(
      scopedTrendRows
        .reduce((acc: any, obj: any) => {
          acc[obj.Level1ColChild] = obj;
          return acc;
        }, {}),
    );

    uniqueColObjects.sort((a: any, b: any) => {
      const aCode = this.parseResponseCode(a.Level1ColResponseCode);
      const bCode = this.parseResponseCode(b.Level1ColResponseCode);

      // Compare year first, then number if years are equal
      if (!Number.isNaN(aCode.year) && !Number.isNaN(bCode.year)) {
        if (aCode.year !== bCode.year) {
          return aCode.year - bCode.year;
        }
      }
      return aCode.num - bCode.num;
    });

    uniqueColObjects.sort((a: any, b: any) => {
      let firstData = a.Level1ColChild ?? '';
      let secondData = b.Level1ColChild ?? '';
      if (firstData.includes("|")) {
        firstData = firstData.split("|")[1]
        secondData = secondData.split("|")[1];

        if (firstData.includes("_")) {
          firstData = firstData.split("_")[1];
          secondData = secondData.split("_")[1];
        }

        firstData = parseInt(firstData);
        secondData = parseInt(secondData);
      } else {
        firstData = parseInt(firstData);
        secondData = parseInt(secondData);

      }
      return firstData - secondData;
    })

    uniqueColObjects.sort((a: any, b: any) => {
      const [monthA, yearA] = (a.Level1ColChild?.split("|")[1] ?? '').split("_");
      const [monthB, yearB] = (b.Level1ColChild?.split("|")[1] ?? '').split("_");

      const dateA: any = new Date(yearA, this.getMonthNumber(monthA) - 1);
      const dateB: any = new Date(yearB, this.getMonthNumber(monthB) - 1);

      return dateA - dateB;
    });

    uniqueColObjects = uniqueColObjects.slice(-6);

    uniqueColObjects.forEach((i: any) => {
      let col = {
        Data: [{
          CalculationType: i.CalculationType,
          Child: i.Level1ColChild ?? '',
          NestedArray: [],
          customCalculationId: null,
          customGroupId: null,
          isCustomCalculation: false,
          isCustomGroup: false,
          isDerived: false,
          responsecode: i.Level1ColResponseCode,
          variablecode: i.Level1NestColVariableCode,
          ChildName: (i.Level1ColChild ?? '').includes("|") ? (i.Level1ColChild ?? '').split("|")[1].trim() : (i.Level1ColChild ?? '')
        }],
        Parent: "Month",
        customCalculationId: null,
        isCustomCalculation: false,
        isCustomGroup: false
      }
      if (!this.opobject.Column.includes(col)) {
        this.opobject.Column.push(col);
      }
    })


    //     Level1ColChild
    // : 
    // "Month|May_2023"
    // Level1ColResponseCode
    // : 
    // "5 2023"
    // Level1NestColVariableCode
    // : 
    // "Month_code"

    this.sampleSizeOutputData = JSON.parse(JSON.stringify(scopedTrendRows));

    this.OutputdataObject = this.opobject;
    this.isSampleSize = true;



    this.isTrendView = false;
    this.isSampleSize = true;

  }

  getMonthNumber(monthAbbr: any): number {
    const months = [
      ["jan", "january"],
      ["feb", "february"],
      ["mar", "march"],
      ["apr", "april"],
      ["may", "may"],
      ["jun", "june"],
      ["jul", "july"],
      ["aug", "august"],
      ["sep", "september"],
      ["oct", "october"],
      ["nov", "november"],
      ["dec", "december"],
    ];

  const normalized = monthAbbr?.toLowerCase().trim();
  const index = months.findIndex((aliases) => aliases.includes(normalized));
  return index + 1; // returns 0 if not found
}

  parseResponseCode(code: any) {
    const [num, year] = code.split(' ');
    return { num: parseInt(num, 10), year: parseInt(year, 10) };
  };

  private isBrandDependentMode(properties: any): boolean {
    const raw =
      properties?.branddependent ??
      properties?.BrandDependent ??
      properties?.bdBiToggle;

    if (raw === undefined || raw === null || raw === '') {
      return true;
    }

    if (typeof raw === 'string') {
      const normalized = raw.trim().toLowerCase();
      return normalized === 'true' || normalized === 'enable';
    }

    return !!raw;
  }

  private isLollipopMetricMode(): boolean {
    const chartName = (this.customData?.widgetchart_name || '').toString().toLowerCase();
   

    let properties: any = {};
    try {
      properties = JSON.parse(this.customData?.customizationProperties || '{}');
    } catch {
      properties = {};
    }

    if (!this.isBrandDependentMode(properties)) {
      return false;
    }

    return (
      (properties?.BrandMetricToggle || 'Brand')
        .toString()
        .trim()
        .toLowerCase() === 'metric'
    );
  }
}
